<template>
  <header class="header-shadow">
    <HeaderEmpty />
  </header>
  <main class="main--empty">
    <slot></slot>
  </main>
  <footer class="bg-background">
    <FooterMain />
  </footer>
</template>

<script setup>
import FooterMain from "@/components/footer/FooterMain.vue";
import HeaderEmpty from "@/components/header/HeaderEmpty.vue";
</script>

<style lang="scss" scoped>
.header-shadow {
  @media (min-width: 768px) {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
}
</style>
